// @flow

import ko from 'knockout';

// Shorthand for `disable: x(), css: { 'busy': x() }`
ko.bindingHandlers.busy = {
	after: ['disable'],

	init (element, valueAccessor, allBindings, viewModel, bindingContext) {

		const isBusy = (): boolean => {
			const value = ko.unwrap(valueAccessor());
			if (value && value.isBusy) {
				return value.isBusy();
			}
			return Boolean(value);
		};

		const isDisable = (): boolean => ko.unwrap(allBindings.get('disable'));

		ko.applyBindingAccessorsToNode(element, {
			disable: () => isBusy() || isDisable(),
			css: () => ({ busy: isBusy() }),
		}, bindingContext);

	},
};

